import React, {useState, useEffect} from 'react';
import CatalogPartnerModal from './CatalogPartnerModal';
import useReactiveMessage from '../../hook/UseReactiveMessage';

const CatalogPartnerModalLoader = (props) => {

  const [documentId, setDocumentId] = useState();
  const [show, setShow] = useState(false);
  const {getMessage} = useReactiveMessage('CATALOG_PARTNER');

  let subscription;
  useEffect(() => {
    subscription = getMessage().subscribe(message => {
      if (message && message.documentId) {
        setDocumentId(message.documentId);
        setShow(true);
      }
    });
  });

  const onCloseHandler = () => {
    setShow(false);
  };

  return (
    <CatalogPartnerModal documentId={documentId} show={show} onCloseHandler={onCloseHandler} />
  )

};

export default CatalogPartnerModalLoader;

